"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/dataAggregatorController',["require", "exports", "controllers/abortingRequest", "providers/ajaxSettingsProvider"], function (require, exports, abortingRequest, ajaxSettingsProvider) {
    "use strict";

    var DataAggregatorController = function () {
        function DataAggregatorController() {
            _classCallCheck(this, DataAggregatorController);
        }

        _createClass(DataAggregatorController, [{
            key: "getLatestPolicyData",
            value: function getLatestPolicyData(data) {
                return abortingRequest.send('/api/DataAggregator/GetLatestPolicyData', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getAllLatestPolicyData",
            value: function getAllLatestPolicyData(data) {
                return abortingRequest.send('/api/DataAggregator/GetAllLatestPolicyData', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getNearbyPolicyholders",
            value: function getNearbyPolicyholders(data) {
                return abortingRequest.send('/api/DataAggregator/GetNearbyPolicyholders', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getPolicyholderLocationByBrokerPolicyId",
            value: function getPolicyholderLocationByBrokerPolicyId(data) {
                return abortingRequest.send('/api/DataAggregator/GetPolicyholderLocationByBrokerPolicyId', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getPolicyholderLocationByPolicyId",
            value: function getPolicyholderLocationByPolicyId(data) {
                return abortingRequest.send('/api/DataAggregator/GetPolicyholderLocationByPolicyId', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getNonTransmittingPolicyholdersLocation",
            value: function getNonTransmittingPolicyholdersLocation(data) {
                return abortingRequest.send('/api/DataAggregator/GetNonTransmittingPolicyholdersLocation', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getUnauthorisedDeviceRemovalPolicyholdersLocation",
            value: function getUnauthorisedDeviceRemovalPolicyholdersLocation(data) {
                return abortingRequest.send('/api/DataAggregator/GetUnauthorisedDeviceRemovalPolicyholdersLocation', ajaxSettingsProvider.httpPost(data));
            }
        }]);

        return DataAggregatorController;
    }();

    return new DataAggregatorController();
});
//# sourceMappingURL=dataAggregatorController.js.map;
